
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieProdottiGrid extends Serenity.EntityGrid<TipologieProdottiRow, any> {
        protected getColumnsKey() { return TipologieProdottiColumns.columnsKey; }
        protected getDialogType() { return TipologieProdottiDialog; }
        protected getIdProperty() { return TipologieProdottiRow.idProperty; }
        protected getInsertPermission() { return TipologieProdottiRow.insertPermission; }
        protected getLocalTextPrefix() { return TipologieProdottiRow.localTextPrefix; }
        protected getService() { return TipologieProdottiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}